export default __webpack_public_path__ + "static/reu-d3ad4e1b83a4d5446316961f49606bb7.jpg";